<template>
  <div>
    <v-card elevation="0" class="pb-2 rounded-lg">
      <div class="pa-4">
        <div class="d-flex justify-space-between align-center mb-2">
          <h5 class="ma-0">Changelogs</h5>
          <v-btn color="primary" @click="newChangelog" small>
            <v-icon small left>mdi-plus</v-icon>
            Novo Changelog
          </v-btn>
        </div>
        <v-alert v-if="error" type="error" class="mb-0">
          {{ error }}
        </v-alert>
        <template v-else>
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            label="Pesquisar"
            single-line
            dense
            hide-details
            outlined
          />

          <v-data-table
            :loading="loading"
            :items="changelogs"
            :headers="headers"
            :search="search"
            class="elevation-0"
          >
            <template v-slot:item.actions="{ item }">
              <v-icon small class="mr-2" @click="editChangelog(item)">
                mdi-pencil
              </v-icon>
              <v-icon small class="mr-2" @click="deleteChangelog(item)">
                mdi-delete
              </v-icon>
            </template>
            <template v-slot:item.publishedAt="{ item }">
              {{
                item.publishedAt
                  ? new Date(item.publishedAt).toLocaleDateString()
                  : "Não publicado"
              }}
            </template>
            <template v-slot:item.category="{ item }">
              <v-chip small label>
                <v-icon left x-small>{{ categories[item.category].icon }}</v-icon>
                {{ categories[item.category].text }}
              </v-chip>
            </template>
            <template v-slot:item.size="{ item }">
              <v-chip small label>
                <v-icon left small>{{ sizes[item.size].icon }}</v-icon>
                {{ sizes[item.size].text }}
              </v-chip>
            </template>
            <template v-slot:item.scope="{ item }">
              <v-chip small label>
                <v-icon left small>{{ scopes[item.scope].icon }}</v-icon>
                {{ scopes[item.scope].text }}
              </v-chip>
            </template>
          </v-data-table>
        </template>
      </div>
    </v-card>
    <ChangelogModal @success="getChangelogs" />
  </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
import CHANGELOG from "@/services/ultimate/changelogs.js";
import ChangelogModal from "@/components/ultimate/changelog/ChangelogCreateModal.vue";

export default {
  components: {
    ChangelogModal,
  },
  metaInfo: {
    title: "Changelogs",
  },
  data() {
    return {
      error: null,
      loading: false,
      changelogs: [],
      search: "",
      headers: [
        { text: "Título", value: "title" },
        { text: "Categoria", value: "category" },
        { text: "Escopo", value: "scope" },
        { text: "Tamanho", value: "size" },
        { text: "Publicado em", value: "publishedAt" },
        { text: "Ações", value: "actions", sortable: false },
      ],
      scopes: {
        GERAL: { text: "Geral", icon: "mdi-home" },
        TECHNICAL: { text: "Técnico", icon: "mdi-account-wrench" },
        ADMIN: { text: "Admin", icon: "mdi-crown" },
      },
      sizes: {
        SMALL: { text: "Pequena", icon: "mdi-circle-small" },
        MEDIUM: { text: "Média", icon: "mdi-circle-medium" },
        LARGE: { text: "Grande", icon: "mdi-circle" },
      },
      categories: {
        NEW_FEATURE: { text: "Nova Funcionalidade", icon: "mdi-plus" },
        PERFORMANCE: { text: "Desempenho", icon: "mdi-speedometer" },
        SECURITY: { text: "Segurança", icon: "mdi-shield-check" },
        BUG_FIX: { text: "Correção de Bug", icon: "mdi-bug" },
        NEW_API: { text: "Nova API", icon: "mdi-api" },
        NEW_REPORT: { text: "Novo Relatório", icon: "mdi-chart-box" },
        NEW_UI: { text: "Nova UI", icon: "mdi-palette" },
        NEW_TOOL: { text: "Novo Tool", icon: "mdi-wrench" },
        OTHER: { text: "Outro", icon: "mdi-information" },
      },
    };
  },
  methods: {
    ...mapActions("auth", ["getPermissions"]),
    newChangelog() {
      this.$root.$emit("changelog-modal");
    },
    editChangelog(changelog) {
      this.$root.$emit("changelog-modal", changelog);
    },
    async getChangelogs() {
      try {
        this.loading = true;
        var response = await CHANGELOG.getAll();
        this.changelogs = response.changelogs;
      } catch (error) {
        this.error = error.message || "Erro ao buscar changelogs";
        console.error(error);
      } finally {
        this.loading = false;
      }
    },
  },

  computed: {
    ...mapGetters("company", ["selectedCompany"]),
    numberOfPages() {
      return Math.ceil(this.changelogs.length / this.itemsPerPage);
    },
  },
  watch: {},
  async mounted() {
    await this.getChangelogs();
  },
};
</script>
